import { LDSSkeleton } from "@resmed/lumina-design-system";

/**
 * Skeleton placeholder for the message panel while messages load.
 * Alternates received / sent / received bubbles to match the real layout.
 */
const SkeletonMessagePanel = () => (
  <div className="lds-flex lds-flex-col lds-gap-6 lds-px-6 lds-py-4">
    {/* Received bubble */}
    <div className="lds-flex lds-items-end lds-gap-3">
      <LDSSkeleton shape="circle" width="2.5rem" height="2.5rem" />
      <div className="lds-flex lds-flex-col lds-gap-1.5">
        <LDSSkeleton shape="rectangle" width="4rem" height="0.75rem" />
        <LDSSkeleton shape="rectangle" width="14rem" height="3.5rem" borderRadius="0.75rem" />
      </div>
    </div>

    {/* Sent bubble */}
    <div className="lds-flex lds-justify-end">
      <LDSSkeleton shape="rectangle" width="12rem" height="3rem" borderRadius="0.75rem" />
    </div>

    {/* Received bubble */}
    <div className="lds-flex lds-items-end lds-gap-3">
      <LDSSkeleton shape="circle" width="2.5rem" height="2.5rem" />
      <div className="lds-flex lds-flex-col lds-gap-1.5">
        <LDSSkeleton shape="rectangle" width="4rem" height="0.75rem" />
        <LDSSkeleton shape="rectangle" width="10rem" height="2.5rem" borderRadius="0.75rem" />
      </div>
    </div>

    {/* Sent bubble */}
    <div className="lds-flex lds-justify-end">
      <LDSSkeleton shape="rectangle" width="16rem" height="4rem" borderRadius="0.75rem" />
    </div>
  </div>
);

export default SkeletonMessagePanel;
